import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import Map from './components/Map';

const queryClient = new QueryClient({});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Map/>
      {/* <ReactQueryDevtools initialIsOpen={false}/> */}
    </QueryClientProvider>
  );
}
